export const appPages = {
  aiAppPages: {
    id: "aiApp",
    to: "/ai",
    text: "AI",
    icon: "HeroRocketLaunch",
    subPages: {
      aiDashboardPage: {
        id: "aiDashboardPage",
        to: "/ai/dashboard",
        text: "AI Dashboard",
        icon: "HeroRocketLaunch",
      },
      chatPages: {
        id: "customerPage",
        to: "/ai/chat",
        text: "Chat Pages",
        icon: "HeroChatBubbleLeft",
        subPages: {
          photoPage: {
            id: "photoPage",
            to: "/ai/chat/photo",
            text: "Photo Editing",
            icon: "HeroPhoto",
          },
          videoPage: {
            id: "videoPage",
            to: "/ai/chat/video",
            text: "Video Generation",
            icon: "HeroFilm",
          },
          audioPage: {
            id: "audioPage",
            to: "/ai/chat/audio",
            text: "Audio Generation",
            icon: "HeroMusicalNote",
          },
          codePage: {
            id: "audioPage",
            to: "/ai/chat/code",
            text: "Code Generation",
            icon: "HeroCommandLine",
          },
        },
      },
    },
  },
  salesAppPages: {
    id: "salesApp",
    to: "/sales",
    text: "Sales",
    icon: "HeroBanknotes",
    subPages: {
      salesDashboardPage: {
        id: "salesDashboardPage",
        to: "/admin/dashboard",
        text: "Company info", //COMPANY INFO
        icon: "CompanyInfo",
      },
      user: {
        id: "user",
        to: "/admin/user",
        text: "User Contacts", //USERS (CONTACTS)
        icon: "UserContacts",
      },
      locations: {
        id: "locations",
        to: "/admin/locations",
        text: "Locations", //USERS (CONTACTS)
        icon: "Locations",
      },
      equipments: {
        id: "equipments",
        to: "/admin/equipments",
        text: "Equipment Assets", //USERS (CONTACTS)
        icon: "EquipmentAssets",
      },
      myAccount: {
        id: "myAccount",
        to: "/admin/myAccount",
        text: "My Accounts", //USERS (CONTACTS)
        icon: "MyAccounts",
      },
      watchList: {
        id: "myAccount",
        to: "/admin/watch-list",
        text: "Watch List", //USERS (CONTACTS)
        icon: "WatchList",
      },
      adminTools: {
        id: "myAccount",
        to: "/admin/admin-tools",
        text: "Admin Tools", //USERS (CONTACTS)
        icon: "AdminTools",
      },
    },
  },
};
